import styled from "styled-components";
import { colors } from "../../../../../consts";
import { Paragraph2, WrapperContainer } from "../../../../../components";

export const CardWrapper = styled(WrapperContainer)`
  background: ${colors.WHITE};
  border-radius: 16px;
  border: 1px solid;
  border-color: ${colors.RAISIN_20};

  padding: 16px;
  width: 100%;
  height: 154px;
`;

export const IconContainer = styled(WrapperContainer)`
  width: 32px;
  height: 32px;
  min-width: 32px;
  border-radius: 10px;

  position: relative;
  overflow: hidden;

  &::after {
    background: ${(props) => props.iconBackground};
    opacity: 0.2;
    width: 100%;
    height: 100%;
    left: 0;

    content: "";
    position: absolute;
  }
`;

export const Title = styled(Paragraph2)`
  font-weight: 700;
`;

export const Info = styled(Paragraph2)`
  font-weight: 800;
  font-size: 22px;
  line-height: 32px;

  span {
    position: relative;
    bottom: 2px;
    left: 4px;

    font-weight: 500;
    font-size: 14px;
    line-height: 25px;

    color: ${colors.RAISIN_80};
  }
`;
